export const gradeOptions = [
  { name: '티어', value: null },
  { name: '아이언', value: 1 },
  { name: '브론즈', value: 2 },
  { name: '실버', value: 3 },
  { name: '골드', value: 4 },
  { name: '플레티넘', value: 5 },
  { name: '다이아', value: 6 },
  { name: '그랜드마스터', value: 7 },
  { name: '마스터', value: 8 },
  { name: '챌린저', value: 9 },
];

export const teamOptions = [
  { value: null, name: '전체 팀' },
  { value: 1, name: 'DWF_KIA' },
  { value: 2, name: 'T1' },
  { value: 3, name: 'Gen_G' },
  { value: 4, name: 'NongShim_REDFORCE' },
  { value: 5, name: 'Liiv_SANDBOX' },
  { value: 6, name: 'Afreeca Freecs' },
  { value: 7, name: 'kt Rolster' },
  { value: 8, name: 'Hanwha_Life_Esports' },
  { value: 9, name: 'Fredit_BRION' },
  { value: 10, name: 'DRX' },
];

export const ageRangeOptions = [
  { value: null, name: '나이' },
  { value: 1, name: '10대' },
  { value: 2, name: '20대' },
  { value: 3, name: '30대' },
  { value: 4, name: '40대' },
  { value: 5, name: '50대' },
];

export const genderOptions = [
  { value: null, name: '성별' },
  { value: 1, name: '여성' },
  { value: 2, name: '남성' },
];
